import { render } from "./ItemDanhSachChuyenDi.vue?vue&type=template&id=3ad6a580&scoped=true"
import script from "./ItemDanhSachChuyenDi.vue?vue&type=script&lang=js"
export * from "./ItemDanhSachChuyenDi.vue?vue&type=script&lang=js"

import "./ItemDanhSachChuyenDi.vue?vue&type=style&index=0&id=3ad6a580&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad6a580"]])

export default __exports__